import {Tooltip} from "@mui/material";
import "../components/about/About/about.css";
import { connect } from 'react-redux';
import { setInfo } from '../redux/actionList';
//import {InputCompletedContext} from '../objects/Context/input_completed_context';
import withRouterCompat from "../objects/CommonUse/with_router_compat";
import AboutGeneral from '../components/about/about_general';
import AboutForParents from '../components/about/about_for_parents';
import InformationSources from '../components/about/information_sources';
import GameObjectives from '../components/about/game_objectives';
import CommentModal from '../components/shared-components/comment_modal';
import Footer from "./footer";
import {Link} from "react-router-dom";
import React from 'react';
import LinkTab from "../components/shared-components/link_tab";
import { setHeadersForFetch } from "../objects/CommonUse/set_headers_for_fetch";
import {buildUrl } from '../objects/CommonUse/build_URL';
import tooltipCommentIconText from "./Text/tooltip_text";
import updateSessionTokenStorage from "./Objects/update_session_token_storage";


// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
};

class AboutPage extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            gameInfo: {},
        }
   
    this.openCommentModal = this.openCommentModal.bind(this);
    this.closeCommentModal = this.closeCommentModal.bind(this);

     this.state = {
        inputArr: [
            {
                completed: false,
                selected: true
            },
            {
                completed: false,
                selected: false
            },
            {
                completed: false,
                selected: false
            },
            {
                completed: false,
                selected: false
            },
        ],
        commentIcon: "./assets/ContactUs/pencilPaper.png",
        commentModalOpen: false,
        fromProcessName: "AboutPage",
        screenSize: sessionStorage.getItem("GameScreenSize"),
        gameInfo: {},
        rerender: false
    };
    switch(props.selected) {
        case "aboutGeneral":
            this.inputSelected(0);
            break;
        case "aboutForParents":
            this.inputSelected(1);
            break;
        case "gameObjectives":
            this.inputSelected(2);
            break;
        case "informationSources":
            this.inputSelected(3);
            break;
        default:
            break;
                    
    }
            
}
    
    onNavigate = (path) => {
        const { navigate, location } = this.props;

        const targetPath = `/${path}`;
        // Only navigate if we aren’t already there
        if (location.pathname !== targetPath) {
            navigate(`/${path}`, { replace: true });
        }
    };

    render(){
        if (this.selected !== this.props.selected){
            updateSessionTokenStorage(this.props.selected);
            this.selected = this.props.selected;
        }            
        console.log("this.state.inputArr: ", this.state.inputArr);     
    return <>
            <span className="container m-0 p-0">
                <span className="row w-100 mx-0">
                  
                    <div className="col-sm-2 mt-4 ">
                        <div>
                            <img  className="train-track-img" src={'./assets/ExtraCredit.png'} 
                                alt="MoneyTrain"/>
                        </div>   
                    </div>
                           
                    {this.props.selected === "aboutGeneral" ? 
                        <AboutGeneral
                            goBack = {() => this.goToHomePage()}
                           /> : <span/>} 
                    {this.props.selected === "aboutForParents" ? 
                        <AboutForParents
                            goBack = {() => this.goToHomePage()}
                           /> : <span/>} 
                    {this.props.selected === "informationSources" ? 
                        <InformationSources
                            goBack = {() => this.goToHomePage()}
                            /> : <span/>}   
                    {this.props.selected === "gameObjectives" ? 
                        <GameObjectives
                            goBack = {() => this.goToHomePage()}
                            /> : <span/>}
                    
                    {this.username === null ?
                        null
                    :
                        <div>
                            <Tooltip title={tooltipCommentIconText} arrow>
                                <img src={this.state.commentIcon} 
                                    className={this.commentIconClass} alt="comment"
                                    onClick={this.openCommentModal} >
                                </img>
                            </Tooltip>
                        </div>
                    }
                
                    {this.state.commentModalOpen ?
                        <CommentModal modalOpen={this.state.commentModalOpen} 
                            onClose={() => this.closeCommentModal()}
                            gamePart={this.state.fromProcessName}
                            processName={this.props.selected}
                            gameInfo = {() => this.getGameInfo()}
                            processError = {(errorObj) => this.processErrorReturn(errorObj)}
                        />
                    :
                        null
                    }
                            
                     <div className="col-sm-2 mt-4">    
                        <Link to="/about-general" onClick={() => this.handleClick(0)}>
                            <LinkTab inputArr={this.state.inputArr[0]} name="Main Page" validToComplete="true" 
                              />
                        </Link>

                        <Link to="/about-for-parents" onClick={() => this.handleClick(1)}>
                             <LinkTab inputArr={this.state.inputArr[1]} name="Parent Perspective" validToComplete="true" 
                             />
                        </Link>
                                         
                        <Link to="/game-objectives" onClick={() => this.handleClick(2)}>
                            <LinkTab inputArr={this.state.inputArr[2]} name="Game Objectives" validToComplete="true" 
                             />
                        </Link>

                        <Link to="/information-sources" onClick={() => this.handleClick(3)}>
                            <LinkTab inputArr={this.state.inputArr[3]} name="Information Sources" validToComplete="true" 
                            />
                        </Link>
                                                             
                        {(this.state.screenSize === "zoom") &&
                            <Footer 
                                screenSize={this.state.screenSize}
                            />
                        }
                    </div>    
    {/*
                {process.env.NODE_ENV === 'development' && (
                        <div className="breakpoint-indicator" />
                        )}
    */}
            </span>
       </span>             
    </>
}

componentDidMount(){
    this._isMounted = true;
    this.setState({rerender: true});
    this.username = sessionStorage.getItem("username");
    if (this.state.screenSize === "ipad" ||
        this.state.screenSize === "zoom"
    ){
        this.commentIconClass = "comment-icon-position comment-img";
    }else{
        this.commentIconClass = "about-comment-icon-position comment-img"; 
    }
}

inputSelected = (inputID) => {
    let inputArr = this.state.inputArr;
    for (const input of inputArr) {
        input.selected = false;
    }
    inputArr[inputID].selected = true;
    if (this._isMounted === true){
        this.setState({inputArr: inputArr});
    }  
        
};

componentWillUnmount(){
    this.props.setInfoRedux("about-general", "prevProcess");
    this._isMounted = false;
}

openCommentModal(){
    this.setState({commentModalOpen: true});
}

closeCommentModal(){
    this.setState({commentModalOpen: false});
}

handleClick = index => {
    this.inputSelected(index);
}


getGameInfo()
{
    return this.state.gameInfo;
}

goToHomePage(){
    this.onNavigate("");
}

processErrorReturn(errorObj){
    this.addRecordToLogfile(errorObj);
    if (!errorObj.silentAlert || errorObj.silentAlert === false){
        alert ("Uh oh!  Something unexpected has occurred " +
            "error has been logged and will be addressed. " +
            "For now click OK, then return to the process " +
            "where you were and try again.");
        this.onNavigate("");
    }
}


addRecordToLogfile(errorObj){
    const headers=setHeadersForFetch();
    if (errorObj.status === 250){
        errorObj.message = "No record found";
    }
    let subProcess = "";  
    if (!errorObj.subProcess){
        subProcess = "unknown"
    }else{
        subProcess = errorObj.subProcess;
    }
    const logFileBody =  {
        mainProcess: "About",
        subProcess: subProcess,
        function: errorObj.function,
        status: errorObj.status,
        message: errorObj.message
    }
    console.log("logFileBody is: ", logFileBody)
    const urlParm = "";
    const uri = buildUrl(this.state.environment, "saveLogFile", urlParm);
    fetch (uri,  
        {method:'POST',
            headers: headers,
            body: JSON.stringify(logFileBody)
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        console.log("logfile create was successful");
                    }else{
                        console.log("Response from save log file not valid!" +
                         " status is: ", output.statusCode,
                         " message is: ", output.body);
                        alert ("Response from save log file not valid!");
                           
                    }
            });
          
        }
    });
  
}

}
export default connect(null, mapDispatchToProps)(withRouterCompat(AboutPage));